module.exports = __webpack_public_path__ + "static/media/search.1aa64b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/search.png
// module id = 2571
// module chunks = 0